import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Tile from '../../Components/Tile';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { deleteStudent, setStudent, getTeacherClasses, getTeacherStudents, setClass, setClassIndex } from '../../../redux';
import { Divider } from 'material-ui';

function ManageStudents (props) {

    const navigate = useNavigate();
    const [state, setState] = useState({
        classIndex: 0,
        isViewingClassMenu: false,
        message: ""
    });

    useEffect(() => {
        props.getTeacherClasses(props.user._id);
        props.getTeacherStudents(props.user._id);
        setState({...state, classIndex: props.classIndex});
    }, []);

    const toggleClassMenu = () => {
        setState({
            ...state,
            isViewingClassMenu: !state.isViewingClassMenu,
        });
    }

    const setStudentAndRedirectToEdit = (student) => {
        props.setStudent(student);
        navigate("/student/overview");
    }

    const redirectToDashboard = () => {
        props.setClassIndex(state.classIndex);
        navigate("/teacher")
    }

    const getMappedStudents = (classObject) => {
        return props.teacherStudents && props.teacherStudents
            .filter(student => student.classes.includes(classObject._id))
            .sort((a, b) => {
                if (a.lastName < b.lastName) return -1;
                if (a.lastName > b.lastName) return 1;
                if (a.firstName < b.firstName) return -1;
                if (a.firstName > b.firstName) return 1;
                return 0;
            });
    }

    const getMappedPossibleDuplicateStudents = (classObject) => {
        const mappedStudents = getMappedStudents(classObject);
        const possibleDuplicates = [];
        const normalizedNames = mappedStudents.map(student => ({
            ...student,
            fullName: `${student.firstName} ${student.lastName}`.toLowerCase(),
            originalName: `${student.firstName} ${student.lastName}`
        }));

        for (let i = 0; i < normalizedNames.length; i++) {
            for (let j = i + 1; j < normalizedNames.length; j++) {
                const name1 = normalizedNames[i].fullName;
                const name2 = normalizedNames[j].fullName;

                // Check for exact match
                if (name1 === name2) {
                    possibleDuplicates.push([normalizedNames[i], normalizedNames[j]]);
                    continue;
                }

                // Check for similar names (e.g., with/without middle name)
                const words1 = name1.split(' ');
                const words2 = name2.split(' ');
                if (words1[0] === words2[0] && words1[words1.length - 1] === words2[words2.length - 1]) {
                    possibleDuplicates.push([normalizedNames[i], normalizedNames[j]]);
                    continue;
                }

                // Check for transposed first/last names
                if (words1[0] === words2[words2.length - 1] && words1[words1.length - 1] === words2[0]) {
                    possibleDuplicates.push([normalizedNames[i], normalizedNames[j]]);
                }
            }
        }
        return possibleDuplicates;
    }

    const handleDropdownChange = (e) => {
        setState({
            ...state,
            classIndex: props.teacherClasses.findIndex(classObject => classObject.name.trim() === e.target.innerText.trim())
        });
    }

    const getMappedClassOptions = () => {
        return props.teacherClasses && props.teacherClasses
                  .map((classObject, index) => {
                      return (
                          <MenuItem
                              key={index + classObject.name}
                              value={classObject.name}
                              primaryText={classObject.name}
                              id="class"
                          />
                      );
                  })
    }

    const manageClasses = () => {
        navigate("/manage/classes")
    }

    const classObject = props.teacherClasses[state.classIndex] || {name: ""}
    const possibleDuplicateStudents = getMappedPossibleDuplicateStudents(classObject);
    return (
        <div className="dashboard">
            <button onClick={redirectToDashboard} className="backButton">
                <img src={require("../../../Images/leftArrow.png")} alt="<-"/>
                Return to Dashboard
            </button>
            <div className="classElement">
                <div className="classChoice">
                    <SelectField
                        name="class"
                        value={classObject.name}
                        onChange={handleDropdownChange}
                        iconStyle={{paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px"}}
                        style={{borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px"}}
                        labelStyle={{color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px"}}
                        underlineStyle={{border: "none"}}
                    >
                        {getMappedClassOptions()}
                    </SelectField>
                </div>
                {state.isViewingClassMenu &&
                    <div className="classMenuWindow">
                        <h4 onClick={manageClasses}>Manage Classes</h4>
                    </div>
                }
                <div className="classMenu" onClick={toggleClassMenu}>
                    <i className="fa fa-ellipsis-v" style={{textAlign: "center", fontSize: "16px", color: "rgba(0, 0, 0, 0.87)"}}></i>
                </div>
            </div>
            {possibleDuplicateStudents.length > 0 ? (
                <>
                    <h4><b style={{color: "red"}}>{'(!)'} Possible Duplicates:</b></h4>
                    <div className="tiles">
                        {possibleDuplicateStudents.map((studentPair, index) => (
                            <div className="tileContainer" key={index} style={{display: "flex", flexDirection: "row", gap: "10px"}}>
                                <Tile
                                    key={index + studentPair[0].firstName}
                                    number={`${studentPair[0].lastName}, ${studentPair[0].firstName}`}
                                    name={studentPair[0].email}
                                    status={`ID: ${studentPair[0].studentId}`}
                                    handleClick={() => setStudentAndRedirectToEdit(studentPair[0])}
                                />
                                <Tile
                                    key={index + studentPair[1].firstName}
                                    number={`${studentPair[1].lastName}, ${studentPair[1].firstName}`}
                                    name={studentPair[1].email}
                                    status={`ID: ${studentPair[1].studentId}`}
                                    handleClick={() => setStudentAndRedirectToEdit(studentPair[1])}
                                />
                            </div>
                        ))}
                    </div>
                    <Divider />
                </>
            ) : null}
            <h1>Students</h1>
            <div className="tiles">
                {getMappedStudents(classObject).map((student, index) => (
                    <div className="tileContainer" key={index}>
                        <Tile
                            key={index + student.firstName}
                            number={`${student.lastName}, ${student.firstName}`}
                            name={student.email}
                            status={`ID: ${student.studentId}`}
                            handleClick={() => setStudentAndRedirectToEdit(student)}
                        />
                    </div>
                ))}
            </div>
            <p className="errorMessage">{state.message}</p>
        </div>
    );
}

export default connect(state => state.root, { deleteStudent, setStudent, getTeacherClasses, getTeacherStudents, setClass, setClassIndex })(ManageStudents);
